"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var CustomPropTypes = _interopRequireWildcard(require("../../../constants/PropTypes"));

var _immutable = _interopRequireDefault(require("immutable"));

var _sizes = require("HubStyleTokens/sizes");

var _unescapedText = _interopRequireDefault(require("I18n/utils/unescapedText"));

var _UIFlex = _interopRequireDefault(require("UIComponents/layout/UIFlex"));

var _UIFormLabel = _interopRequireDefault(require("UIComponents/form/UIFormLabel"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _UISelect = _interopRequireDefault(require("UIComponents/input/UISelect"));

var _UITooltip = _interopRequireDefault(require("UIComponents/tooltip/UITooltip"));

var PlanType = _interopRequireWildcard(require("ecosystem-marketplace-core/constants/pricings/PlanType"));

var FilterKey = _interopRequireWildcard(require("../../../constants/search/FilterKey"));

var SortField = _interopRequireWildcard(require("../../../constants/search/SortField"));

var SortOrder = _interopRequireWildcard(require("../../../constants/search/SortOrder"));

var _StorefrontFilters = require("../../../records/StorefrontFilters");

var MENU_ITEM_HEIGHT = parseInt(_sizes.DROPDOWN_ITEM_DEFAULT_HEIGHT, 10);
var MENU_PADDING_Y = parseInt(_sizes.DROPDOWN_PADDING_Y, 10);

var fieldOrderTuples = _immutable.default.OrderedSet([[SortField.RELEVANCE, SortOrder.DESC], [SortField.HUB_INSTALLS, SortOrder.DESC], [SortField.FIRST_PUBLISHED, SortOrder.DESC], [SortField.OVERALL_RATING, SortOrder.DESC], [SortField.PRICE, SortOrder.ASC], [SortField.PRICE, SortOrder.DESC], [SortField.NAME, SortOrder.ASC], [SortField.NAME, SortOrder.DESC]]);

var getI18nKey = function getI18nKey(key) {
  return "appMarketplace.storefront.results.sortDropdown." + key;
};

var getOptionI18nKey = function getOptionI18nKey(sortField, sortOrder) {
  var key = function () {
    switch (sortField) {
      case SortField.RELEVANCE:
        return 'relevance';

      case SortField.HUB_INSTALLS:
        return 'mostInstalled';

      case SortField.FIRST_PUBLISHED:
        return 'newest';

      case SortField.OVERALL_RATING:
        return 'overallRating';

      case SortField.PRICE:
        return sortOrder === SortOrder.ASC ? 'priceLowHigh' : 'priceHighLow';

      case SortField.NAME:
        return sortOrder === SortOrder.ASC ? 'name' : 'nameReverse';

      default:
        return null;
    }
  }();

  return getI18nKey("options." + key);
};

var getOptionValue = function getOptionValue(field, order) {
  return field + ":" + order;
};

var SortSelectItem = function SortSelectItem(_ref) {
  var children = _ref.children,
      option = _ref.option;
  return _react.default.createElement(_UITooltip.default, {
    delay: 200,
    disabled: !option.tooltip,
    placement: "left",
    title: option.tooltip
  }, children);
};

var SortDropdown = function SortDropdown(_ref2) {
  var disabled = _ref2.disabled,
      filters = _ref2.filters,
      onChange = _ref2.onChange;
  var collection = filters[FilterKey.COLLECTION],
      planType = filters[FilterKey.PRICING],
      searchValue = filters[FilterKey.SEARCH],
      sortField = filters[FilterKey.SORT_FIELD],
      sortOrder = filters[FilterKey.SORT_ORDER];
  var handleChange = (0, _react.useCallback)(function (_ref3) {
    var value = _ref3.target.value;

    var _value$split = value.split(':'),
        _value$split2 = (0, _slicedToArray2.default)(_value$split, 2),
        field = _value$split2[0],
        order = _value$split2[1];

    onChange(field, order);
  }, [onChange]);

  var _useMemo = (0, _react.useMemo)(function () {
    return searchValue ? [SortField.RELEVANCE, SortOrder.DESC] : [(0, _StorefrontFilters.getDefaultSortField)(collection), (0, _StorefrontFilters.getDefaultSortOrder)(collection)];
  }, [searchValue, collection]),
      _useMemo2 = (0, _slicedToArray2.default)(_useMemo, 2),
      defaultField = _useMemo2[0],
      defaultOrder = _useMemo2[1];

  var value = (0, _react.useMemo)(function () {
    var field = defaultField;
    var order = defaultOrder;

    if (sortField) {
      field = sortField;
      order = sortOrder || defaultOrder;
    }

    return getOptionValue(field, order);
  }, [defaultField, defaultOrder, sortField, sortOrder]);
  var options = (0, _react.useMemo)(function () {
    return fieldOrderTuples.filter(function (_ref4) {
      var _ref5 = (0, _slicedToArray2.default)(_ref4, 1),
          field = _ref5[0];

      if (field === SortField.RELEVANCE && !searchValue) {
        return false;
      }

      if (collection && !(0, _StorefrontFilters.isValidSortField)(collection, field)) {
        return false;
      }

      return true;
    }).map(function (_ref6) {
      var _ref7 = (0, _slicedToArray2.default)(_ref6, 2),
          field = _ref7[0],
          order = _ref7[1];

      var option = {
        value: getOptionValue(field, order),
        text: (0, _unescapedText.default)(getOptionI18nKey(field, order))
      };

      if (field === SortField.PRICE) {
        option.disabled = planType === null || planType === PlanType.FREE;
        option.tooltip = option.disabled ? (0, _unescapedText.default)(getI18nKey('priceTooltip')) : null;
      }

      return option;
    }).toArray();
  }, [collection, planType, searchValue]);
  var totalOptions = options.length;
  var minHeight = (0, _react.useMemo)(function () {
    return totalOptions * MENU_ITEM_HEIGHT + MENU_PADDING_Y * 2;
  }, [totalOptions]);
  return _react.default.createElement(_UIFlex.default, {
    align: "center",
    justify: "end",
    wrap: "wrap"
  }, _react.default.createElement(_UIFormLabel.default, {
    className: "p-y-0"
  }, _react.default.createElement(_FormattedMessage.default, {
    message: getI18nKey('label')
  })), _react.default.createElement(_UISelect.default, {
    buttonUse: "link",
    disabled: disabled,
    itemComponent: SortSelectItem,
    menuStyle: {
      minHeight: minHeight
    },
    menuWidth: "auto",
    onChange: handleChange,
    options: options,
    value: value
  }));
};

SortDropdown.propTypes = {
  disabled: _propTypes.default.bool,
  filters: CustomPropTypes.storefrontFilters.isRequired,
  onChange: _propTypes.default.func.isRequired
};
var _default = SortDropdown;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/storefront/results/SortDropdown.js
// module id = 904
// module chunks = 209 210 211 212